<template>
  <div class="error-page">
    <!-- Skip to main content link -->
    <a href="#main-content" class="skip-to-main">Skip to main content</a>

    <!-- Top Bar -->
    <header role="banner">
      <div class="topbar centered" :class="[partnerLogo ? 'topbar--white' : '']">
        <div class="wrapper" style="width: 100%;">
          <template v-if="partnerTypeId === 2 && partnerLogo">
            <img class="topbar__logo" :src="partnerLogo" alt="Partner logo">
          </template>
          <template v-else-if="partnerTypeId === 1 && partnerLogo">
            <div style="display:flex; align-items:center; gap:.5rem;">
              <img class="topbar__logo" :src="partnerLogo" alt="Partner logo">
              <img class="topbar__logo" :src="logoRed" alt="Clio Muse Tours logo">
            </div>
          </template>
          <template v-else>
            <img class="topbar__logo" :src="logoWhite" alt="Clio Muse Tours logo">
          </template>
        </div>
      </div>
    </header>

    <main id="main-content" class="main-content">
      <div class="error-container">
        <img
          class="error__image"
          src="/support/support.svg"
          alt=""
          role="presentation"
          aria-hidden="true"
        />

        <h1 class="error_message__text" role="alert" aria-live="assertive">
          {{ error.statusMessage || 'We are sorry, but there was an error.' }}
        </h1>

        <p class="error_message__subtext">
          If you need any assistance, please refer to the contact details below.
        </p>
      </div>
    </main>

    <!-- Footer without partner branding -->
    <Footer 
      partner-logo=""
      partner-title=""
      partner-email=""
      :partner-type-id="null"
    />
  </div>
</template>

<script setup>
import Footer from './components/Footer.vue';

useHead({
  title: 'Booking Check-in'
});

const props = defineProps({
  error: {
    type: Object,
    required: true
  }
});

// No partner data for error page, but keep variables for topbar structure
const partnerLogo = null;
const partnerTypeId = null;

const logoWhite = "/logos/clio-muse-tours-logo-white.svg";
const logoRed = "/logos/clio-muse-tours-logo-red.svg";
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  max-width: 600px;
  text-align: center;
}

.error__image {
  width: 200px;
  height: auto;
  margin-bottom: 1rem;
}

.error_message__text {
  color: var(--main-color);
  text-align: center;
  font-size: 1.375rem;
  font-weight: 600;
  line-height: 2rem;
  margin: 0 0 1rem;
}

.error_message__subtext {
  color: #161616;
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 640px) {
  .main-content {
    padding: 2rem 1rem;
  }

  .error__image {
    width: 150px;
  }

  .error_message__text {
    font-size: 1.125rem;
  }
}
</style>